/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Direction_From_MasterInputs */



/**
* | output |
* | --- |
* | "Master → box" |
*
* @param {Mesh_Direction_From_MasterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_direction_from_master = /** @type {((inputs?: Mesh_Direction_From_MasterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Direction_From_MasterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Master → box")
	return /** @type {LocalizedString} */ ("Inverser direction")
});